import MarkdownRenderer from './MarkdownRenderer';
import type { LighthouseAudit } from '@/app/PageSpeed/api/types/analysisApiTypes';

type Props = { audit: LighthouseAudit };

const DefaultAuditRenderer = ({ audit }: Props) => {
  return (
    <div className="fs--1">
      <MarkdownRenderer content={audit.description} />
    </div>
  );
};

export default DefaultAuditRenderer;
